"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalColony = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const BuildColony_1 = require("../../../deferredActions/BuildColony");
const Resources_1 = require("../../../Resources");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../../render/CardRenderer");
class VitalColony extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.VITAL_COLONY,
            metadata: {
                cardNumber: 'Y18',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.colonies(1).colonyPlacementBonus().br;
                    b.minus().megacredits(5);
                }),
                description: 'Place a colony. Gain its placement bonus a second time. Pay 5 M€.',
            },
        });
    }
    play(player) {
        const coloniesBeforeBuilding = [];
        const game = player.game;
        game.colonies.forEach((colony) => {
            if (colony.colonies.includes(player.id)) {
                coloniesBeforeBuilding.push(colony.name);
            }
        });
        game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build colony'));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            game.colonies.forEach((colony) => {
                if (colony.colonies.includes(player.id) && !coloniesBeforeBuilding.includes(colony.name)) {
                    colony.giveBonus(player, colony.buildType, colony.buildQuantity[colony.colonies.length - 1], colony.buildResource);
                }
            });
            return undefined;
        }));
        player.deductResource(Resources_1.Resources.MEGACREDITS, 5);
        return undefined;
    }
}
exports.VitalColony = VitalColony;
//# sourceMappingURL=VitalColony.js.map